import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import "./equivalents.styles.scss";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 800,
    border: "1px solid #3c8dbc",
    margin: "auto",
    marginBottom: 30,
  },
  content: {
    padding: 0,
    fontFamily: "Roboto, sans-serif",
  },
  pos: {
    marginBottom: 12,
  },
  table: {
    padding: "16px 16px 0",
  },
  header: {
    backgroundColor: "#3c8dbc",
    padding: "16px",
    color: "#fff",
  },
});

export default function OutlinedCard({ units, inputValue, fromValue }) {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent className={classes.content}>
        <Typography component="h2" className={classes.header}>
          Equivalent
        </Typography>
        <div className={classes.table}>
          <div className="table-row table-row-header">
            <div className="table-cell">
              <strong>Name</strong>
            </div>
            <div className="table-cell table-cell-right">
              <strong>Number (approx.)</strong>
            </div>
            <div className="table-cell">
              <strong>Assumption made</strong>
            </div>
          </div>
          {units.map(
            ({ assumption, name, isUnit, conversion }, index) =>
              !isUnit && (
                <div className="table-row" key={index}>
                  <div className="table-cell">
                    <span className="table-text">{name}</span>
                  </div>
                  <div className="table-cell table-cell-right">
                    <span className="table-text">
                      {fromValue && inputValue && conversion
                        ? (
                            (inputValue * conversion) /
                            units.filter((item) => item.name === fromValue)[0]
                              ?.conversion
                          ).toPrecision(8)
                        : "-"}
                    </span>
                  </div>
                  <div className="table-cell">
                    <span className="table-text">{assumption}</span>
                  </div>
                </div>
              )
          )}
        </div>
      </CardContent>
    </Card>
  );
}
